import React from 'react';
import './Footer.css';

function Footer() {
  return (  
        <div className='footer-container'>
            <div className='footer'>
                <p className='rights'> &copy; All rights reserved 2022</p>
                <p className='designedby'> Designed by Yazharasu</p>
            </div>
        </div>
    )
}

export default Footer;